import { generateApiUrl } from "@/shared/utils";
/* eslint-disable no-console */
/* eslint-disable no-useless-catch */
import httpService from "@/shared/http";
import { pathOr } from "ramda";

export const getAttachments = async (caseId, page, getPerPage) => {
  try {
    const queryString = { page, per_page: getPerPage };
    const url = generateApiUrl(
      ["kanoon", "centerExecuteCaseAttachments"],
      [caseId],
      queryString
    );
    const response = await httpService.get(url);
    const data = pathOr(null, ["data", "data"], response);
    const permissions = pathOr([], ["data", "permissions"], response);
    const others = pathOr(null, ["data", "others"], response);
    const total = pathOr(0, ["total"], data);
    const count = pathOr(0, ["count"], data);
    const totalPages = pathOr(0, ["total_pages"], data);
    const currentPage = pathOr(1, ["current_page"], data);
    const perPage = pathOr(10, ["per_page"], data);
    const result = pathOr([], ["result", "data"], data);

    const items = result.map((item) => {
      const code = pathOr(null, ["code"], item);
      const attachmentType = pathOr(null, ["attachment_type"], item);
      const attachmentTypeCaption = pathOr(
        "",
        ["attachment_type", "caption"],
        item
      );
      const caption = pathOr("", ["caption"], item);
      const thumbnail = pathOr("", ["thumb"], item);
      const originalFile = pathOr("", ["url"], item);
      const fileSuffix = pathOr("", ["ext"], item).toLocaleLowerCase();
      return {
        code,
        attachmentType,
        attachmentTypeCaption,
        caption,
        thumbnail,
        originalFile,
        fileSuffix,
      };
    });

    return {
      total,
      count,
      totalPages,
      currentPage,
      perPage,
      items,
      others,
      permissions,
    };
  } catch (error) {
    throw error;
  }
};
export const createAttachment = async (caseId, files) => {
  try {
    const url = generateApiUrl(
      ["kanoon", "centerExecuteCaseAttachments"],
      [caseId]
    );
    const payload = { files };
    const response = await httpService.post(url, payload);
    const message = pathOr(null, ["data", "message"], response);

    return { message };
  } catch (error) {
    throw error;
  }
};
export const updateAttachment = async ({
  caseId,
  attachmentCode,
  attachmentTypeId,
  attachmentCaption,
}) => {
  try {
    const url = generateApiUrl(
      ["kanoon", "centerExecuteCaseAttachment"],
      [caseId, attachmentCode]
    );
    const payload = {
      attachment_type_id: attachmentTypeId,
      caption: attachmentCaption,
    };
    const response = await httpService.put(url, payload);
    const message = pathOr(null, ["data", "message"], response);

    return { message };
  } catch (error) {
    throw error;
  }
};
export const deleteAttachment = async (caseId, attachmentCode) => {
  try {
    const url = generateApiUrl(
      ["kanoon", "centerExecuteCaseAttachment"],
      [caseId, attachmentCode]
    );
    const response = await httpService.delete(url);
    const message = pathOr(null, ["data", "message"], response);

    return { message };
  } catch (error) {
    throw error;
  }
};
